import { instance } from '../api/api';
import { formatDateForApi } from '../utils/date.utils';

// Интерфейсы для технических осмотров
export interface ICarImage {
  carID: string;
  createdAt: string;
  id: string;
  photoType: string;
  photoUrl: string;
}

export interface ITechCheck {
  body: boolean;
  carID: string;
  carImages: ICarImage[];
  chassis: boolean;
  checkStatus: string;
  checkTime: string;
  engine: boolean;
  id: string;
  num: number;
  odometerPhoto: string;
  odometerReading: number;
  optic: boolean;
  reasonForRefusal: string;
  technicFullName: string;
  technicID: string;
}

export interface ITechCheckResponse {
  checks: ITechCheck[];
  limit: number;
  page: number;
  total: number;
}

export interface TechCheckFilters {
  page?: number;
  limit?: number;
  startTime?: string;
  endTime?: string;
}

export const TechCheckService = {
  // Получение списка технических осмотров водителя
  async getDriverTechChecks(driverID: string, filters: TechCheckFilters = {}): Promise<ITechCheckResponse> {
    try {
      const queryParams = new URLSearchParams();

      // Копируем фильтры и форматируем даты
      const formattedFilters = { ...filters };

      // Форматируем даты, если они есть
      if (filters.startTime) {
        formattedFilters.startTime = formatDateForApi(filters.startTime);
      }

      if (filters.endTime) {
        formattedFilters.endTime = formatDateForApi(filters.endTime);
      }

      // Добавляем параметры в URL
      Object.entries(formattedFilters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      const { data } = await instance.get<ITechCheckResponse>(`/techlist/driver/${driverID}${queryString}`);

      // Обработка данных перед возвратом для гарантии корректного формата
      const processedData = {
        ...data,
        checks: data.checks.map((check) => ({
          ...check,
          // Убедимся, что carImages всегда массив
          carImages: Array.isArray(check.carImages) ? check.carImages : check.carImages ? [check.carImages] : [],
        })),
      };

      return processedData;
    } catch (error: any) {
      console.error('Ошибка при получении технических осмотров:', error);
      throw new Error(error.response?.data?.message || 'Не удалось получить технические осмотры водителя');
    }
  },

  // Получение одного технического осмотра по ID
  async getTechCheckById(checkId: string): Promise<ITechCheck> {
    try {
      const { data } = await instance.get<ITechCheck>(`/techlist/${checkId}`);
      return data;
    } catch (error: any) {
      console.error('Ошибка при получении технического осмотра:', error);
      throw new Error(error.response?.data?.message || 'Не удалось получить технический осмотр');
    }
  },
};
